import { z } from "zod";

export const BatchPrintPreferenceSchema = z.enum(["LabelsOnly", "LabelsWithPackingSlips"]);
export const ShippingDocumentsContentDisposition = z.enum(["attachment", "inline"]);
